import RenderManager from "../rendering/render-manager";

const tmpMesh = new THREE.Mesh(undefined, new THREE.MeshBasicMaterial({ color: 0xff00ff }));
const raycaster = new THREE.Raycaster();

class AssessmentRaySticker {
    constructor({ object, plopGeometry, plops }) {
        this._object = object;
        this._plopGeometry = plopGeometry;
        this._plops = plops;
    }

    get object() { return this._object; }

    update() { }

    plop() { }

    pickup() { }
    release() { }

    check(mouse) {
        tmpMesh.geometry = this._plopGeometry;

        raycaster.setFromCamera(mouse, RenderManager.activeCamera);

        const intersections = [];

        this._plops.forEach(matrix => {
            const itscts = [];
            matrix.decompose(tmpMesh.position, tmpMesh.quaternion, tmpMesh.scale);
            tmpMesh.updateMatrixWorld();

            tmpMesh.raycast(raycaster, itscts);

            const itsct = itscts[0] || null;

            if (!itsct) return;

            itsct.matrix = matrix;

            intersections.push(itsct);
        });

        const intersection = intersections.sort((a, b) => a.distance - b.distance)[0] || null;

        if (!intersection) return;

        intersection.matrix.decompose(this._object.position, this._object.quaternion, this._object.scale);
    }
}

export default AssessmentRaySticker;
export { AssessmentRaySticker };